/* JACKZER Paddock — copy-to-clipboard for discount code chips */
(function () {
  function init() {
    document.querySelectorAll('.jz-code[data-code]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var code = chip.getAttribute('data-code');
        var hint = chip.querySelector('.jz-code__hint');
        var original = hint ? hint.textContent : '';
        function done() {
          chip.classList.add('is-copied');
          if (hint) hint.textContent = 'COPIED ✓';
          setTimeout(function () {
            chip.classList.remove('is-copied');
            if (hint) hint.textContent = original;
          }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
